 <template>
  <header class="header parallax">
    <div class="name">
      <div class="wrapper-name">
          <h1 class="animate__animated animate__slideInLeft">Rocio Perez</h1>
          <p>{{ $t('architect') }}</p>
          <hr />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "LandingPage"
};
</script>

<style scoped lang="scss">
@import "@/styles/constants.scss";



.header {
  padding: 20px;
  background-color: map-get($colors, dark);
  
}

.parallax {
  background-image: url("../assets/img/bg.png");
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
}

.name {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  z-index: 400;

  .wrapper-name {
    width: 250px;
  }

  h1 {
    font-size: 3rem;
    padding: 2px 2px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(0, 0, 0);
    animation: slide-in-left 0.5s ease-in-out forwards;
  }

  @keyframes slide-in-left {
    0% {
      transform: translateX(-100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  p {
    font-size: 2rem;
    text-align: right;
    margin: 5px auto;
    color: rgb(0, 0, 0);
    animation: slide-in-left 0.7s ease-in-out forwards;
  }

  @keyframes slide-in-right {
    0% {
      transform: translateX(0);
      opacity: 0;
    }
    100% {
      transform: translateX(-100%);
      opacity: 1;
    }
  }

  hr {
    border: 1px solid rgb(0, 0, 0);
    width: 130%;
    position: relative; 
    right: 30%; 
  }
}

@media (max-width: #{map-get($breakpoints, small)}) {
  .name {
    margin: -7.5% auto;
  }
}

@media (min-width: #{map-get($breakpoints, small)}) {
  .name {
    .wrapper-name {
      width: 55%;
    }
    h1 {
      font-size: 5rem;
      padding: 0% 8%;
    }
    p {
      font-size: 2rem;
      padding: 0% 4%;
    }
  }
}
@media (min-width: #{map-get($breakpoints, medium)}) {
  .name {
    .wrapper-name {
      width: 450px;
    }
    h1 {
      font-size: 4rem;
      padding: 0% 5%;
    }
    p {
      font-size: 3rem;
      padding: 0% 5%;
    }
  }
}
@media only screen and (max-device-width: 1024px) {
  .parallax {
    background-attachment: scroll;
  }
}
</style>
